<template>
    <div id="dashboard-loading" v-loading="loading">
        <div class="vx-col w-full">
            <vx-card title="Clientes">
                <template slot="actions"> </template>
                <div slot="no-body" class="p-6 pb-0">
                <div class="flex">
                    <vs-button class="float-right mr-5" @click.prevent="downloadExcelClient()">
                        <i class="fa fa-file-excel mr-1"></i>
                        Exportar Excel
                    </vs-button>
                    <vs-button class="float-right mr-5" color="blue" @click="importExcelClient()">
                        <i class="fa fa-upload"></i>
                        Importar Clientes
                    </vs-button>
                    <vs-button class="float-right mr-5" color="red" @click="deleteAllClient()">
                        <i class="fa fa-trash"></i>
                        Limpiar
                    </vs-button>
                </div>
                </div>
            </vx-card>
        </div>
        <div class="vx-col w-full">
            <vx-card title="Productos">
                <template slot="actions"> </template>
                <div slot="no-body" class="p-6 pb-0">
                <div class="flex">
                    <vs-button class="float-right mr-5" @click.prevent="downloadExcelItem()">
                        <i class="fa fa-file-excel mr-1"></i>
                        Exportar Excel
                    </vs-button>
                    <vs-button class="float-right mr-5" color="blue" @click="importExcelItem()">
                        <i class="fa fa-upload"></i>
                        Importar Productos
                    </vs-button>
                    <vs-button class="float-right mr-5" color="red" @click="deleteAllItem()">
                        <i class="fa fa-trash"></i>
                        Limpiar
                    </vs-button>
                </div>
                </div>
            </vx-card>
        </div>

        <el-dialog title="Importar Excel" :visible.sync="importFileDialogClient">
            <el-alert
                :title="titleImport"
                type="warning"
                :closable="false"
                show-icon>
            </el-alert>
            <br>
            <el-upload
                class="upload-demo"
                :action="url_apiClient"
                :headers="headerInfoClient"
                :limit="1"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                :auto-upload="false"
                :data="dataUploadClient"
                :on-exceed="handleExceedClient"
                :on-change="changeUploadImportFileClient"
                :on-remove="removeUploadImportFileClient"
                :before-upload="beforeUploadImportFileClient"
                :on-success="successUploadImportFileClient"
                :on-error="errorUploadImportFileClient"
                ref="upload">
            <div class="text-center">
                <el-button slot="trigger" size="small" type="primary">Selecciona un archivo</el-button>
                <div slot="tip" class="el-upload__tip">Solo archivos excel (xls/xlxs)</div>
            </div>
            </el-upload>
            <span slot="footer" class="dialog-footer">
                <el-button @click="importFileDialogClient = false">Cancelar</el-button>
                <el-button type="primary" :disabled="!importFileReadyClient"  @click="uploadImportFileClient">Subir</el-button>
            </span>
        </el-dialog>

        <el-dialog title="Importar Excel" :visible.sync="importFileDialogItem">
            <el-alert
                :title="titleImport"
                type="warning"
                :closable="false"
                show-icon>
            </el-alert>
            <br>
            <el-upload
                class="upload-demo"
                :action="url_apiItem"
                :headers="headerInfoItem"
                :limit="1"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                :auto-upload="false"
                :data="dataUploadItem"
                :on-exceed="handleExceedItem"
                :on-change="changeUploadImportFileItem"
                :on-remove="removeUploadImportFileItem"
                :before-upload="beforeUploadImportFileItem"
                :on-success="successUploadImportFileItem"
                :on-error="errorUploadImportFileItem"
                ref="upload">
            <div class="text-center">
                <el-button slot="trigger" size="small" type="primary">Selecciona un archivo</el-button>
                <div slot="tip" class="el-upload__tip">Solo archivos excel (xls/xlxs)</div>
            </div>
            </el-upload>
            <span slot="footer" class="dialog-footer">
                <el-button @click="importFileDialogItem = false">Cancelar</el-button>
                <el-button type="primary" :disabled="!importFileReadyItem"  @click="uploadImportFileItem">Subir</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import clientsService from "@/services/clients.service";
import itemsService from "@/services/items.service.js";
import loading from "@/components/Loading.vue";
import helpers from "@/helpers/helpers";

export default {
  name: "bulk-load",
  data() {
    return {
      loading: false,
      searchData: {},
      importFileDialogClient: false,
      importFileReadyClient: false,
      titleImport: "El archivo debe ser igual al excel que se exporta en este mismo módulo.",
      dataUploadClient: {
         import: "clients"
      },
      importFileDialogItem: false,
      importFileReadyItem: false,
      dataUploadItem: {
         import: "items"
      }
    };
  },
  computed: {
    url_apiClient() {
      return clientsService.uploadImportFile().url
    },
    headerInfoClient() {
      return clientsService.uploadImportFile().headers
    },
    url_apiItem() {
      return itemsService.uploadImportFile().url
    },
    headerInfoItem() {
      return itemsService.uploadImportFile().headers
    }
  },
  methods: {
    deleteAllClient() {
      
      this.$confirm("¿ Deseas eliminar todos los clientes ?", "Eliminar Clientes", {
          confirmButtonText: "Si, continuar",
          cancelButtonText: "Cancelar",
          type: "warning",
          center: true
        })
          .then(() => {
            this.loading = true;
            clientsService.deleteAllClients()
              .then(() => {
                this.loading = false;
                this.$message({
                  type: "success",
                  message: "Clientes eliminados"
                });
              })
              .catch(() => {
                this.loading = false;
                this.$message({
                  type: "error",
                  message: "Ocurrio un problema"
                });
              });

          })
          .catch(() => {
            this.loading = false;
            this.$message({
              type: "info",
              message: "Acción cancelada"
            });
          });
    },
    downloadExcelClient() {
      this.loading = true;
      this.searchData.export = 'excel'
      clientsService.getOnlyClients(0, false, this.searchData)
      .then(res => {
        delete this.searchData.export
        this.loading = false;
        helpers.downloadBlob(res.data, `lista-clientes.xlsx`)
      }).catch(error => {
        delete this.searchData.export
        this.loading = false;
        this.$message({
          showClose: true,
          message: error.response.data.message,
          type: 'error'
        });
      })
    },
    importExcelClient() {
      this.titleImport = "El archivo debe ser igual al excel que se exporta en este mismo módulo.";
      this.importFileDialogClient = true
    },
    errorUploadImportFileClient(err) {
      this.loading = false
      this.$refs.upload.clearFiles()
      this.$message({
        showClose: true,
        message: `Ocurrio un error al subir el archivo`,
        type: 'error'
      });
    },
    successUploadImportFileClient(response) {
      if(response.success) {
        this.loading = false
        this.$refs.upload.clearFiles()
        this.$message({
          showClose: true,
          message: 'Se ha cargado el archivo correctamente, espere mientras se actualizan los datos...',
          type: 'success'
        });
      }
    },
    beforeUploadImportFileClient() {
      this.loading = true
      this.importFileDialogClient = false
    },
    removeUploadImportFileClient() {
      this.importFileReadyClient = false
    },
    changeUploadImportFileClient(file) {
      if(file)
        this.importFileReadyClient = file.status == 'ready' ? true : false
      else 
        this.importFileReadyClient = false
    },
    handleExceedClient() {
      this.$message.warning(`El límite de archivos es 1`);
    },
    uploadImportFileClient() {
      this.$refs.upload.submit();
    },
    deleteAllItem() {
      
      this.$confirm("¿ Deseas eliminar todos los productos ?", "Eliminar Productos", {
          confirmButtonText: "Si, continuar",
          cancelButtonText: "Cancelar",
          type: "warning",
          center: true
        })
          .then(() => {
            this.loading = true;
            itemsService.deleteAllItems()
              .then(() => {
                this.loading = false;
                this.$message({
                  type: "success",
                  message: "Productos eliminados"
                });
              })
              .catch(() => {
                this.loading = false;
                this.$message({
                  type: "error",
                  message: "Ocurrio un problema"
                });
              });

          })
          .catch(() => {
            this.loading = false;
            this.$message({
              type: "info",
              message: "Acción cancelada"
            });
          });
    },
    downloadExcelItem() {
      this.loading = true;
      this.searchData.export = 'excel'
      itemsService.getItems(0, this.searchData)
      .then(res => {
        delete this.searchData.export
        this.loading = false;
        helpers.downloadBlob(res.data, `lista-productos.xlsx`)
      }).catch(error => {
        delete this.searchData.export
        this.loading = false;
        this.$message({
          showClose: true,
          message: error.response.data.message,
          type: 'error'
        });
      })
    },
    importExcelItem() {
      this.titleImport = "El archivo debe ser igual al excel que se exporta en este mismo módulo.";
      this.importFileDialogItem = true
    },
    errorUploadImportFileItem(err) {
      this.loading = false
      this.$refs.upload.clearFiles()
      this.$message({
        showClose: true,
        message: `Ocurrio un error al subir el archivo`,
        type: 'error'
      });
    },
    successUploadImportFileItem(response) {
      if(response.success) {
        this.loading = false
        this.$refs.upload.clearFiles()
        this.$message({
          showClose: true,
          message: 'Se ha cargado el archivo correctamente, espere mientras se actualizan los datos...',
          type: 'success'
        });
      }
    },
    beforeUploadImportFileItem() {
      this.loading = true
      this.importFileDialog = false
    },
    removeUploadImportFileItem() {
      this.importFileReadyItem = false
    },
    changeUploadImportFileItem(file) {
      if(file)
        this.importFileReadyItem = file.status == 'ready' ? true : false
      else 
        this.importFileReadyItem = false
    },
    handleExceedItem() {
      this.$message.warning(`El límite de archivos es 1`);
    },
    uploadImportFileItem() {
      this.$refs.upload.submit();
    },
  },
  components: {
    loading,
  }
};
</script>

